import React, { useState, useEffect, useRef } from 'react';
import { Button, TextInput, Popover } from '..';
import { chevronIcon } from './functions/icons';
import { useEffectAfterMount } from '../../utils/hooks';
export const RangeSelector = ({ type, metric, min, max, fromInputValue, toInputValue, setInputValue, label, setLabel, languageData, validateInputFormat, isValidValue, invalidRange, onCloseValidation, isCompletedValueFormat, popoverStatus, }) => {
    const lastFromValue = useRef('');
    const lastToValue = useRef('');
    const [fromValid, setFromValid] = useState(true);
    const [toValid, setToValid] = useState(true);
    const isValid = fromValid && toValid;
    const [isOpen, setIsOpen] = useState(false);
    const { from: fromAriaLabel, to: toAriaLabel, buttonTitle, validationError, placeholder: { from: placeholderFrom, to: placeholderTo }, } = languageData;
    useEffect(() => {
        if (popoverStatus) {
            popoverStatus(isOpen);
        }
    }, [isOpen]);
    useEffectAfterMount(() => {
        // Send back the newest 'completed' value to update the label
        // For reusability, the logic to construct the label will be handled ouside the component
        if (setLabel && isValidValue(fromInputValue, min, max)) {
            setLabel(fromInputValue, 'from');
        }
        if (setLabel && isValidValue(toInputValue, min, max)) {
            setLabel(toInputValue, 'to');
        }
        // Check validity
        if (!fromInputValue && !toInputValue) {
            setFromValid(true);
            setToValid(true);
        }
        else {
            if (isCompletedValueFormat(fromInputValue)) {
                setFromValid(isValidValue(fromInputValue, min, max));
            }
            if (isCompletedValueFormat(toInputValue)) {
                setToValid(isValidValue(toInputValue, min, max));
            }
        }
    }, [fromInputValue, toInputValue]);
    const onValueChange = (newValue, source) => {
        const lastValue = source === 'from' ? lastFromValue.current : lastToValue.current;
        const { isValid, value } = validateInputFormat(lastValue, newValue);
        if (isValid) {
            if (source === 'from') {
                lastFromValue.current = value;
            }
            else {
                lastToValue.current = value;
            }
            setInputValue(value, source);
        }
    };
    const selectedRangeLabel = () => {
        if (label) {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "range-selector_button--title" },
                    buttonTitle,
                    ": "),
                React.createElement("span", { className: "range-selector_button--items" }, label)));
        }
        return React.createElement("span", { className: "range-selector_button--title" }, buttonTitle);
    };
    const getErrorText = () => {
        // override the validation and display error - range is invalid
        if (invalidRange) {
            return invalidRange.validationError;
        }
        return !isValid ? validationError : '';
    };
    const handlePopOverToggle = () => {
        if (!isOpen) {
            setIsOpen(true);
        }
    };
    const handlePopOverClose = () => {
        const { isFromInvalid, isToInvalid } = onCloseValidation(fromInputValue, toInputValue);
        if (isFromInvalid) {
            setFromValid(false);
        }
        if (isToInvalid) {
            setToValid(false);
        }
        if ((isValid && isCompletedValueFormat(fromInputValue) && isCompletedValueFormat(toInputValue)) ||
            (!fromInputValue && !toInputValue)) {
            // override the validation and keep the popover open - range is invalid
            if (invalidRange) {
                setIsOpen(true);
            }
            else {
                setIsOpen(false);
            }
        }
        else {
            setIsOpen(true);
        }
    };
    return (React.createElement(Popover, { position: "bottom-left", transitionDuration: 0, onInteraction: () => handlePopOverToggle(), onClose: () => handlePopOverClose(), isOpen: isOpen, autoFocus: false },
        React.createElement(Button, { className: "range-selector_button--category", style: "subtle", rightIcon: chevronIcon }, selectedRangeLabel()),
        React.createElement("div", { className: "filter-popover-content" },
            React.createElement("section", { className: "range-selector-container" },
                React.createElement(TextInput, { className: `range-selector ${type}`, label: metric ? metric : undefined, value: fromInputValue, state: fromValid ? (invalidRange && invalidRange.from ? 'error' : 'default') : 'error', "aria-label": fromAriaLabel, "aria-atomic": "true", onBlur: () => {
                        isCompletedValueFormat(fromInputValue)
                            ? setFromValid(isValidValue(fromInputValue, min, max))
                            : !toInputValue
                                ? setFromValid(true)
                                : setFromValid(false);
                    }, onChange: (e) => onValueChange(e.target.value, 'from'), placeholder: placeholderFrom, autoFocus: true }),
                React.createElement("div", { className: "range-selector-to" }, "to"),
                React.createElement(TextInput, { className: `range-selector ${type}`, label: metric ? metric : undefined, value: toInputValue, state: toValid ? (invalidRange && invalidRange.to ? 'error' : 'default') : 'error', "aria-label": toAriaLabel, "aria-atomic": "true", onBlur: () => {
                        isCompletedValueFormat(toInputValue)
                            ? setToValid(isValidValue(toInputValue, min, max))
                            : !fromInputValue
                                ? setToValid(true)
                                : setToValid(false);
                    }, onChange: (e) => onValueChange(e.target.value, 'to'), placeholder: placeholderTo })),
            React.createElement("div", { className: "range-selector-error" }, getErrorText()))));
};
//# sourceMappingURL=RangeSelector.js.map